import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VmeCommonModule } from '../../../vme-common.module';

@Component({
  selector: 'dialog-progress',
  standalone: true,
  imports: [CommonModule, VmeCommonModule],
  templateUrl: './dialog-progress.component.html',
  styleUrls: ['./dialog-progress.component.scss'],
})
export class DialogProgressComponent implements OnInit {
  @Input() steps!: number;
  @Input() currentStep: number = 0;
  showSummary: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  get stepsArray() {
    return Array.from({ length: this.steps }, (_, i) => i);
  }
}
